(function(angular){
    'use strict';

    angular.module('aprima-core-ui').component('apErxRequestFullRow', {
        templateUrl: '/core-ui/component-views/ap-erx-request-full-row.html',
        bindings: {
            label: '<?',
            value: '<',
            header: '&',
        },
        transclude: true,
        controllerAs: 'vm',
        controller: [
            ApErxRequestFullRow,
        ],
    });

    function ApErxRequestFullRow(
    ) {
    }

})(window.angular);
